import { render, staticRenderFns } from "./LayoutLogin.vue?vue&type=template&id=b36716f6&scoped=true&"
var script = {}
import style0 from "./LayoutLogin.vue?vue&type=style&index=0&lang=css&"
import style1 from "./LayoutLogin.vue?vue&type=style&index=1&id=b36716f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b36716f6",
  null
  
)

export default component.exports